/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_V1_Username_UnavailableInputs */

const en_onboarding_v1_username_unavailable = /** @type {(inputs: Onboarding_V1_Username_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`That username is taken.`)
};

const de_onboarding_v1_username_unavailable = /** @type {(inputs: Onboarding_V1_Username_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dieser Benutzername ist bereits vergeben.`)
};

const pt_br2_onboarding_v1_username_unavailable = /** @type {(inputs: Onboarding_V1_Username_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esse nome de usuário já está em uso.`)
};

const tr_onboarding_v1_username_unavailable = /** @type {(inputs: Onboarding_V1_Username_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bu kullanıcı adı alınmış.`)
};

const zh_cn2_onboarding_v1_username_unavailable = /** @type {(inputs: Onboarding_V1_Username_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此用户名已被占用。`)
};

const zh_hk2_onboarding_v1_username_unavailable = /** @type {(inputs: Onboarding_V1_Username_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`此用戶名稱已被使用。`)
};

const ko_kr2_onboarding_v1_username_unavailable = /** @type {(inputs: Onboarding_V1_Username_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이미 사용 중인 사용자 이름입니다.`)
};

const ru_ru2_onboarding_v1_username_unavailable = /** @type {(inputs: Onboarding_V1_Username_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Это имя пользователя уже занято.`)
};

const es_419_onboarding_v1_username_unavailable = /** @type {(inputs: Onboarding_V1_Username_UnavailableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ese nombre de usuario ya está en uso.`)
};

/**
* | output |
* | --- |
* | "That username is taken." |
*
* @param {Onboarding_V1_Username_UnavailableInputs} inputs
* @param {{ locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }} options
* @returns {LocalizedString}
*/
export const onboarding_v1_username_unavailable = /** @type {((inputs?: Onboarding_V1_Username_UnavailableInputs, options?: { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_V1_Username_UnavailableInputs, { locale?: "en" | "de" | "pt-BR" | "tr" | "zh-CN" | "zh-HK" | "ko-KR" | "ru-RU" | "es-419" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_onboarding_v1_username_unavailable(inputs)
	if (locale === "de") return de_onboarding_v1_username_unavailable(inputs)
	if (locale === "pt-BR") return pt_br2_onboarding_v1_username_unavailable(inputs)
	if (locale === "tr") return tr_onboarding_v1_username_unavailable(inputs)
	if (locale === "zh-CN") return zh_cn2_onboarding_v1_username_unavailable(inputs)
	if (locale === "zh-HK") return zh_hk2_onboarding_v1_username_unavailable(inputs)
	if (locale === "ko-KR") return ko_kr2_onboarding_v1_username_unavailable(inputs)
	if (locale === "ru-RU") return ru_ru2_onboarding_v1_username_unavailable(inputs)
	return es_419_onboarding_v1_username_unavailable(inputs)
});